module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ArticleTagList":{"heading":"Tagy"}},"de":{"ArticleTagList":{"heading":"Tags"}},"sk":{"ArticleTagList":{"heading":"Tagy"}}}')
  delete Component.options._Ctor
}
